import classNames from 'classnames'
import { Link } from 'react-router'
import * as styles from './ghost-button.css.ts'

type GhostButtonProps = {
  children: React.ReactNode
  type?: 'default' | 'secondary'
  state?: 'default' | 'disabled'
  size?: 'default' | 'small'
  href?: string
  to?: string
  className?: string
  label?: string
  onClick?: (event: any) => void
  onKeyDown?: (event: any) => void
}

export function GhostButton({
  children,
  type = 'default',
  state = 'default',
  size = 'default',
  href,
  to,
  className,
  label,
  onClick,
  onKeyDown,
}: GhostButtonProps) {
  if (to)
    return (
      <Link
        className={classNames(styles.button({ type, state, size }), className)}
        to={state === 'disabled' ? '#' : to}
        onMouseDown={e => {
          // Disable focus outline on mouse down for links
          e.preventDefault()
          return
        }}
        onClick={e => {
          // Disable click on disabled links
          if (state === 'disabled') {
            e.preventDefault()
            return
          }
          onClick?.(e)
        }}
        onKeyDown={e => {
          // Disable keydown on disabled links
          if (state === 'disabled') {
            e.preventDefault()
            return
          }
          onKeyDown?.(e)
        }}
        aria-label={label}
      >
        {children}
      </Link>
    )

  if (href)
    return (
      <a
        className={classNames(styles.button({ type, state, size }), className)}
        href={state === 'disabled' ? '#' : href}
        onMouseDown={e => {
          e.preventDefault()
        }}
        onClick={onClick}
        onKeyDown={onKeyDown}
        aria-label={label}
      >
        {children}
      </a>
    )

  return (
    <button
      className={classNames(styles.button({ type, state, size }), className)}
      disabled={state === 'disabled'}
      onMouseDown={e => {
        e.preventDefault()
      }}
      onClick={onClick}
      onKeyDown={onKeyDown}
      aria-label={label}
    >
      {children}
    </button>
  )
}
